// src/config.js

export const DASHBOARD_NAME = "Chambers Of AM";